import React from 'react';
import QueueContainer from '../../containers/inboxPanel/QueueContainer';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import '../../styles/react_dates_overrides.css';
import InboxButtonContainer from '../../containers/tools/InboxButtonContainer';
import { InboxButtonWrapper } from '../common/buttonsComponents';
import InboxTabPickerContainer from '../../containers/inboxPanel/InboxTabPickerContainer';
import AllTabFilters from './AllTabFilters/AllTabFilters';
import EscalatedTabFilters from './EscalatedTabFilters';
import CtaTicketsHolder from './CtaTicketsHolder/CtaTicketsHolder';
import { NOMINATED_FOR_REVIEW } from 'constants/ticketStatuses';
import * as tabs from '../../constants/tabNames';
import { Inbox, QueueContainerWrapper, QueueContainerRow, InboxTabPickerWrapper } from './Inbox.styles';

class InboxComponent extends React.Component {
  isLoadingActive() {
    return this.props.loading && this.props.loading.isLoading && this.props.loading.component === 'inbox';
  }

  render() {
    const { isAdmin, selectedInboxTab, isAPartnerProtector, hasTickets } = this.props;

    return (
      <Inbox name="inbox-component" className="widget full-height">
        <InboxTabPickerWrapper>
          <InboxButtonWrapper>
            <InboxButtonContainer />
            <InboxTabPickerContainer />
          </InboxButtonWrapper>
        </InboxTabPickerWrapper>
        {isAdmin && selectedInboxTab === tabs.ALL && <AllTabFilters />}
        {isAdmin && selectedInboxTab === tabs.NOMINATED && <EscalatedTabFilters />}
        <QueueContainerRow $hasTickets={hasTickets}>
          <QueueContainerWrapper>
            {isAPartnerProtector && (
              <CtaTicketsHolder
                status={NOMINATED_FOR_REVIEW}
                tickets={this.props.reviewTickets}
                iconSrc={'/images/new-designs/queue-component/review-ticket-icon.svg'}
                onTicketButtonClick={this.props.handleReviewTicketSelect}
                renderCtaText={(ticketType) => `Please review this ${ticketType} ticket`}
              />
            )}
            <QueueContainer />
          </QueueContainerWrapper>
        </QueueContainerRow>
      </Inbox>
    );
  }
}

export default InboxComponent;
